import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RealCompetition } from 'src/app/classes/real_competition';
import { RealSeason } from 'src/app/classes/real_season';
import { RealSeasonService } from 'src/app/services/real-season.service';

@Component({
  selector: 'app-realseason-single',
  templateUrl: './realseason-single.component.html',
  styleUrls: ['./realseason-single.component.scss']
})
export class RealSeasonSingleComponent implements OnInit {
  pathList: string[][];
  single: RealSeason;
  id: number;
  rels: any[];
  busy: Subscription;
  SeasonPart = "Nuova Stagione"
  constructor(private ar: ActivatedRoute, private router: Router, public realSeasonService: RealSeasonService) {
    this.pathList = [['RealSeasons', 'real_season/list']];
  }
  
  loga($event) {
    this.pathList.push($event);
  }

  ngOnInit(): void {
    this.rels = [];
    this.id = parseInt(this.ar.snapshot.paramMap.get('id'), 10);
    this.single = new RealSeason();
  }

}
